import { ApiHeaderInfoOk } from 'src/types/v1-api-types';
import { route } from '@services/symfony';

/**
 * @description Returns the link for the home page based on the user role
 * @param headerInfo
 */
export const getAuthLink = (headerInfo: ApiHeaderInfoOk) => (headerInfo.role === 'COMPANY' ? route('app_talent_feed') : '/');
